import React from 'react';
import { Link, useLocation } from 'react-router';
import './Footer.css';

const Footer: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const getFooterLinks = () => {
    switch (currentPath) {
      case '/privacy-policy':
        return (
          <>
            <Link to="/" className="footer-link">Home</Link>
            <span className="footer-separator">|</span>
            <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
          </>
        );
      case '/terms-and-conditions':
        return (
          <>
            <Link to="/" className="footer-link">Home</Link>
            <span className="footer-separator">|</span>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          </>
        );
      default: // Home page
        return (
          <>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <span className="footer-separator">|</span>
            <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
          </>
        );
    }
  };

  return (
    <div className="footer">
      <p>&copy; 2025 Prime Telehealth. All rights reserved.</p>
      <div className="footer-links">
        {getFooterLinks()}
      </div>
    </div>
  );
};

export default Footer;
